var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ArcgisCdn } from './components/ArcgisCdn';
/**
 * ArcGIS React web-component wrapped with a CDN loader.
 *
 * @param {ArcgisMapCdnProps} props - The component props.
 * @param {Function} [props.onArcgisViewReadyChange] - Callback invoked when the ArcGIS map view is ready. Receives the map container element.
 * @param {React.ReactNode} props.children - React children to render within the map context.
 * @returns {React.ReactElement} The ArcGIS map container with its children.
 */
export const ArcgisMapCdn = (props) => {
    return (React.createElement(ArcgisCdn, null,
        React.createElement(ArcgisMap, Object.assign({}, props))));
};
const ArcgisMap = (_a) => {
    var { children, onArcgisViewReadyChange } = _a, props = __rest(_a, ["children", "onArcgisViewReadyChange"]);
    const argisMapRef = React.useRef(null);
    React.useEffect(() => {
        const arcgisMapElement = argisMapRef.current;
        const handleArcgisViewReadyChange = () => {
            onArcgisViewReadyChange === null || onArcgisViewReadyChange === void 0 ? void 0 : onArcgisViewReadyChange(arcgisMapElement);
        };
        if (arcgisMapElement) {
            arcgisMapElement.addEventListener('arcgisViewReadyChange', handleArcgisViewReadyChange);
        }
        return () => {
            if (arcgisMapElement) {
                arcgisMapElement.removeEventListener('arcgisViewReadyChange', handleArcgisViewReadyChange);
            }
        };
    }, [onArcgisViewReadyChange]);
    return React.createElement('arcgis-map', Object.assign(Object.assign({}, props), { ref: argisMapRef }), children);
};
